import { apiCall } from "./Interceptor";

const ADD_USER = "/user/add";
const DELETE_USER = "/user/delete";

const addNewUserFromCompanyAdmin = async (data) => {
    const response = await apiCall.post(ADD_USER,data);
    return response;
}

const deleteUserFromCompanyAdmin = async (id) => {
    const response = await apiCall.delete(`${DELETE_USER}?userId=${id}`);
    return response;
}
export default {
    addNewUserFromCompanyAdmin,
    deleteUserFromCompanyAdmin,
};
